import { render, staticRenderFns } from "./DemoButtonSpeedDial.vue?vue&type=template&id=4a5729c6&scoped=true&"
import script from "./DemoButtonSpeedDial.vue?vue&type=script&lang=js&"
export * from "./DemoButtonSpeedDial.vue?vue&type=script&lang=js&"
import style0 from "./DemoButtonSpeedDial.vue?vue&type=style&index=0&id=4a5729c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5729c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
